export class ScorecardResult
{
    kpiParameterId: any;
    measurable: any;
    trend6month: any;
    trend6monthgoal: any;
    goal: string;
    value: any;
    impvalue: any;
    type: string;
    goalicon: string;
    sparklineval1: any;
    sparklineval2: any;
    sparklinevalmax: number;
    sparklinevalmin: number;
	goalSymbol?: string;
}